import { render, staticRenderFns } from "./choosePersonDialog.vue?vue&type=template&id=b38bae1a&scoped=true"
import script from "./choosePersonDialog.vue?vue&type=script&lang=js"
export * from "./choosePersonDialog.vue?vue&type=script&lang=js"
import style0 from "./choosePersonDialog.vue?vue&type=style&index=0&id=b38bae1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38bae1a",
  null
  
)

export default component.exports